import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/IJOTPromotions.css";
import { MoveUpRight, X } from "lucide-react";
import { MdOutlinePictureAsPdf } from "react-icons/md";

const IJOTPromotions = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // Fetch promotions from backend
 // Fetch promotions from backend
useEffect(() => {
  const fetchPromotions = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('Fetching from URL:', `${process.env.REACT_APP_BASEURL}/getAllPromotionsCMS`);
      
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/getAllPromotionsCMS`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const apiResponse = await response.json();
      console.log('Full API Response:', apiResponse);
      
      // Check if response is successful and has data
      if (apiResponse.success && apiResponse.data && Array.isArray(apiResponse.data)) {
        console.log('API Data:', apiResponse.data);
        console.log('Total promotions received:', apiResponse.data.length);
        
        // No filtering - display all promotions from backend
        setPromotions(apiResponse.data);
      } else {
        console.error('Invalid response structure:', apiResponse);
        throw new Error(apiResponse.message || 'Invalid response format');
      }
    } catch (err) {
      console.error('Error fetching promotions:', err);
      setError(`Failed to load promotions: ${err.message}`);
      setPromotions([]);
    } finally {
      setLoading(false);
    }
  };

  fetchPromotions();
}, []);

  // Handle promotion click to open PDF in viewer
  const handlePromotionClick = (promotion) => {
    setSelectedPdf(promotion);
    setShowPdfModal(true);
  };

  // Close PDF modal
  const handleClosePdfModal = () => {
    setShowPdfModal(false);
    setSelectedPdf(null);
  };

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="ijot-promotion-section">
            <Container className="mt-5">
              <h2 className="text-center ijot-promotions-heading mb-2">IJOT Promotions</h2>
              <h6 className="text-center mb-4">
                The Following Certification Resources are available under AIOTA
              </h6>

              {/* Loading State */}
              {loading && (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3">Loading promotions...</p>
                </div>
              )}

              {/* Error State */}
              {error && (
                <div className="alert alert-danger text-center" role="alert">
                  {error}
                  <br />
                  <small>Check console for more details</small>
                </div>
              )}

              {/* Promotions Grid */}
              {!loading && !error && (
                <Row className="g-4">
                  {promotions.length > 0 ? (
                    promotions.map((promo, index) => (
                      <Col xs={12} sm={12} md={6} lg={4} key={promo._id || index}>
                        <Button 
                          className="promo-btn w-100 h-auto p-4 d-flex justify-content-between align-items-center"
                          onClick={() => handlePromotionClick(promo)}
                        >
                          <div className="d-flex align-items-center gap-3 text-start">
                            <MdOutlinePictureAsPdf size={56} className="d-none d-sm-block" />
                            <span className="promo-title">{promo.title}</span>
                          </div>
                          <MoveUpRight size={32} className="d-none d-sm-block" />
                        </Button>
                      </Col>
                    ))
                  ) : (
                    <Col xs={12}>
                      <div className="text-center py-5">
                        <p className="text-muted">No promotions available at the moment.</p>
                      </div>
                    </Col>
                  )}
                </Row>
              )}
            </Container>
          </section>
        </div>
      </div>

      {/* PDF Viewer Modal */}
      <Modal 
        show={showPdfModal} 
        onHide={handleClosePdfModal} 
        size="xl" 
        centered
        className="pdf-viewer-modal"
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title>{selectedPdf?.title || "PDF Viewer"}</Modal.Title>
          <Button 
            variant="outline-secondary" 
            onClick={handleClosePdfModal}
            className="close-btn"
          >
            <X size={24} />
          </Button>
        </Modal.Header>
        <Modal.Body className="p-0">
          {selectedPdf && (
            <div className="pdf-viewer-container">
              <iframe
                src={selectedPdf.file_url}
                title={selectedPdf.title}
                width="100%"
                height="600px"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <Button className="new-tab"
            variant="primary" 
            onClick={() => window.open(selectedPdf?.file_url, '_blank')}
          >
            Open in New Tab
          </Button>
          <Button variant="secondary" onClick={handleClosePdfModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default IJOTPromotions;